import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PARTNER_URL } from '../../connection.data';

@Injectable()
export class PartnerService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PARTNER_URL;
    }
}